<template>
    <div id="quickssy">
        <ul class="list">
            <li :class="{active:active == 52}" @click="active = 52">
                <p class="a">充多少送多少</p>
                <h1>11<span>元</span></h1>
                <p class="b">充值11元送11元 <br>2200个书币+书豆</p>
                <div class="active"><i class="el-icon-check"></i></div>
            </li>
            <li :class="{active:active == 53}" @click="active = 53">
                <p class="a">充的多送的多</p>
                <h1>51<span>元</span></h1>
                <p class="b">充值51元送61元 <br>11200个书币+书豆</p>
                <div class="active"><i class="el-icon-check"></i></div>

            </li>
        </ul>
        <div class="c" :class="{active:active == 54}" @click="active = 54">
            <h1>111<span>元</span></h1>
            <p class="b">充值111元送189元30000个书币+书豆</p>
            <div class="active"><i class="el-icon-check"></i></div>

        </div>
        <div class="btn" @click="show=true"></div>

        <div class="type" v-if="show" @click="show=false">
            <ul class="btn-list">
                <li class="wechat" :class="{active:type == 6}" @click="setType(6)">
                    <img src="http://static.yuread.cn/quick/wechat1.png" alt=""> 微信充值
                </li>
                <li class="zfb" :class="{active:type == 7}" @click="setType(7)">
                    <img src="http://static.yuread.cn/quick/zfb1.png" alt=""> 支付宝
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Ssy",
        data(){
            return {
                active : 53,
                type : 6,
                show : false,
            }
        },
        methods : {
            setType(type){
                this.type = type;
                system.postMessage(JSON.stringify({
                    active : this.active,
                    type : this.type
                }))
            }
        },
    }
</script>

<style lang="less">
    #quickssy{width: 100%;height: 100%;min-height:1500px;background: url("http://static.yuread.cn/upload/activity/11bg.jpg");background-size: 100% 100%;padding-top: 600px;
        .list{
            width: 670px;display: flex;justify-content: space-between;margin:0 auto;

            li{height: 320px;width: 315px;background-image: url("http://static.yuread.cn/upload/activity/11b.png");background-size: 100% 100%;position: relative;
                .a{text-align: center;font-size: 30px;color: #f91311;line-height: 50px;}
                h1{text-align: center;color: #f91311;font-size: 96px;font-style: oblique;padding-top: 20px;
                    span{font-size: 30px;}
                }
                .b{text-align: center;font-size: 26px;color: #f91311;padding-top: 26px;}
                .active{position:absolute;top:10px;right:10px;width: 40px;height:40px;border-radius: 50%;border:2px solid #f91311;text-align: center;display: none;
                    i{font-size: 30px;position: relative;top:-4px;font-weight: bold;color: #f91311;}
                }

            }
            .active{
                .active{display: block;}
            }
        }
        .c{width: 670px;height:319px;margin: 40px auto;background-image: url("http://static.yuread.cn/upload/activity/11a.png");background-size: 100% 100%;position: relative;
            h1{text-align: center;color: #f91311;font-size: 96px;font-style: oblique;padding-top: 70px;
                span{font-size: 30px;}
            }
            .b{text-align: center;font-size: 37px;color: #f91311;padding-top: 37px;}
            .active{position:absolute;top:10px;right:10px;width: 40px;height:40px;border-radius: 50%;border:2px solid #f91311;text-align: center;display: none;
                i{font-size: 30px;position: relative;top:-4px;font-weight: bold;color: #f91311;}
            }
        }
        .active{
            .active{display: block;}
        }

        .type{
            background-color: rgba(0,0,0,.3);position: fixed;top:0;left:0;right:0;bottom:0;
            .btn-list{ position:absolute;bottom:0;width: 100%;background-color: #fff;display: flex;justify-content: space-between;padding: 102px 40px 68px;border-radius: 58px 58px 0 0;
                li{width: 308px;height:86px;text-align: center;border-radius: 43px;color: #fff;font-size: 32px;line-height: 86px;}
                .wechat{background-color: #32BE1B;}
                .zfb{background-color: #1296db;}
                img{width: 34px;height:34px;position: relative;top:5px;}
            }
        }

        .btn{width: 596px;height: 100px;background-image: url("http://static.yuread.cn/upload/activity/11c.png");background-size: 100% 100%;margin:0 auto;}
    }
</style>
